<template>
  <div class="categories" id="categories">
    <div class="container">
      <div class="categories__wrapper">
        <div class="categories__top">
          <h2 class="categories__title">{{ t('home.categories.title1') }} <span>{{ t('home.categories.title2') }}</span></h2>
          <router-link :to="translations.i18nRoute({ name: 'market' })">
            {{ t('buttons.viewAll') }}
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M6.375 3.75L11.625 9L6.375 14.25" stroke="#01AC1B" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </router-link>
        </div>
        <div class="categories__main">
          <router-link
              :to="translations.i18nRoute({ name: 'market', query: { categoriesSlugs: category.node.slug } })"
              class="categories__main-item"
              v-for="category in categories"
              :key="category.node.uuid"
          >
            <div>
              <img :src="category.node.image" :alt="category.node.name">
            </div>
            <p>{{ category.node.name }}</p>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useCategoryStore} from "@/stores/category.js";
import {useI18n} from "vue-i18n";
import translations from "@/core/helpers/translations.js";

const {t} = useI18n()
const categoryStore = useCategoryStore()

const categories = computed(() => categoryStore.categories)
</script>

<style lang="scss" scoped>
.categories {
  padding-top: 100px;

  &__top {
    display: flex;
    align-items: center;
    justify-content: space-between;

    & a {
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 5px;
      padding: 10px;
      background-color: transparent;
      transition: 0.2s;

      color: #222;
      font-size: 16px;
      font-weight: 500;
      line-height: 18px;

      & svg {
        transition: 0.2s;
      }

      @include hover {
        & svg {
          transform: rotate(1turn);
        }
      }
    }
  }

  &__title {
    padding-bottom: 10px;
    color: #666;
    font-size: 24px;
    font-weight: 700;
    line-height: 30px;

    & span {
      color: #01AC1B;
    }
  }

  &__main {
    margin-top: 30px;
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    flex-wrap: wrap;
    gap: 25px;

    &-item {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 15px;
      cursor: pointer;

      & div {
        background-color: #CDE7CF;
        border-radius: 50%;
        padding: 15px;
        width: 130px;
        height: 130px;
        display: grid;
        place-items: center;
        border: 1px solid #CDE7CF;
        transition: 0.2s;

        & img {
          width: 80%;
        }
      }

      & p {
        color: #222;
        text-align: center;
        font-weight: 500;
        line-height: 20px;
      }

      @include hover {
        & div {
          border-color: #01AC1B;
          filter: drop-shadow(0 0 0 rgba(0, 0, 0, 0.05)) drop-shadow(0 2px 5px rgba(0, 0, 0, 0.05)) drop-shadow(1px 10px 10px rgba(0, 0, 0, 0.04)) drop-shadow(2px 22px 13px rgba(0, 0, 0, 0.03)) drop-shadow(4px 40px 16px rgba(0, 0, 0, 0.01)) drop-shadow(6px 62px 17px rgba(0, 0, 0, 0.00));
        }
      }
    }
  }
}

@media (max-width: 500px) {
  .categories {
    &__title {
      padding-bottom: 5px;
      font-size: 20px;
    }
  }
}
</style>